import { LuIcon } from "@overmap-ai/blocks"

import { modelIconMapping } from "../../../mappings/icons"
import { TextFilterDef } from "../TextFilterDef"

export class IssueTitleFilterDef extends TextFilterDef {
	readonly id = "issue-title"
	readonly icon = <LuIcon icon={modelIconMapping.text} />
	readonly label = "Title"
}
